<script>

import Layout from "../../layouts/main";
import { doctorNames, chatData, chatMessagesData } from "./data";
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";
import appConfig from "@/app.config";
import Heading from "../../layouts/heading";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Form Builder",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, Heading
  },
  data() {
    return {
      schema: new Object(),
      formData: new Object(),
      form: {
        title: null,
        heading: {
          label: null,
          test_check: null,
        },
        paragraph: {
          label: null
        },
        input: {
          type: 'choose',
          label: null,
          required: false,
          info: false,
          character_count: 0,
          wrapper_class: null,
          options: []
        }
      },
      valueTextArea: '',
      valueNote: '',
      value: null,
      enabled5: false,
      tempOption: null,
      editorData: "Hello World",
      chatData: chatData,
      chatMessagesData: chatMessagesData,
      doctorNames: doctorNames,
      page: {
        title: "Form Builder",
        lastUpdated: '',
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: true
      },
      username: "Frank Vickery",
      openingHoursPage: {
        'name': 'Opening Hours Page',
        'slug': 'opening_hours_age',
        'desc': 'Opening Desc',
        'note': 'Opening Note',        
      },
      s: false
    };
  },
  methods: {
    addHeading() {
      if(this.form.heading.label)
      {
        this.schema[Date.now()] = this.heading;
        this.form.heading.label = null;
      }
    },
    addParagraph() {
      if(this.form.paragraph.label)
      {
        this.schema[Date.now()] = this.paragraph;
        this.form.paragraph.label = null;
      }
    },
    addInput() {
      var date = Date.now()
      this.schema[date] = this.input;
      this.formData[date] = {};
      for(var x in this.input.options)
      {
        this.formData[date][this.input.options[x]] = false;
      }
      this.form.input = {
        type: 'choose',
        label: null,
        required: false,
        info: false,
        character_count: 0,
        wrapper_class: null,
        options: []
      }
    },
    removeField(key) {
      delete this.schema[`${key}`];
      delete this.formData[`${key}`];
      this.form.paragraph.label = this.form.paragraph.label == null ? '' : null;
      this.form.paragraph.label = this.form.paragraph.label == '' ? null : '';
    },
    addOption() {
      this.form.input.options.push(this.tempOption);
      this.tempOption = null;
    },
    deleteOption(value) {
      this.form.input.options = this.form.input.options.filter(item => item !== value)
    },
    submit(val) {
      if(val)
      {
        var data = {
          uuid: uuidv4(),
          creationDate: new Date().toISOString(),
          lastModifiedDate: new Date().toISOString(),
          expiryTime: new Date().toISOString(),
          cmsId: 0,
          fields: {},
          additionalProp1: {
            title: this.form.title,
            schema: this.schema,
            formData: this.formData
          }
        };
        api.post('/api/forms', data)
        .then(() => {
          // console.log(response);
          Swal.fire("Form Created!", "Form Created Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
    },
  },
  computed: {
    heading: function () {
      return {
        type: 'heading',
        label: this.form.heading.label
      }
    },
    paragraph: function () {
      return {
        type: 'paragraph',
        label: this.form.paragraph.label
      }
    },
    input: function () {
      return {
          type: this.form.input.type,
          label: this.form.input.label,
          required: this.form.input.required,
          info: this.form.input.info,
          character_count: this.form.input.character_count,
          wrapper_class: this.form.input.wrapper_class,
          options: this.form.input.options
      }
    },
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page" @form-submitted="submit"></Heading>

    <div class="d-lg-flex mb-4">

      <div class="w-100 mt-4 mt-sm-0">
        <div class="p-3 px-lg-4">
          <div class="row px-2">
          
            <form class="needs-validation w-100">
              <div class="row">
                <div v-for="item, key in schema" :key="key" class="mb-3" :class="item.wrapper_class ? item.wrapper_class : 'col-md-12'"
                style="border: 1px solid #DADCE3;"
                  >
                  <button 
                  @click.prevent="removeField(key)"
                  class="btn fas fa-trash-alt text-danger font-size-24"
                  style = "position: absolute;right:0px"></button>
                  <div class="form-group">
                    <div v-if="item.type == 'seperator'" class="w-100 my-4" style="border-bottom: 1px solid #DADCE3;"></div>
                    <div v-if="item.label" class="d-flex">
                      <label
                      class="pr-2 my-2 align-self-sm-center"
                      :class="item.type == 'heading' ? 'font-size-30' : '' ||
                      item.type == 'paragraph' ? 'font-weight-normal' : ''"
                      :for="key + _uid">{{item.label}}<span v-if="item.required"
                      > *</span></label>
                      <i v-if="item.info" class="ri-information-fill my-auto font-size-18 font-gray-color"></i>
                      <p v-if="item.character_count > 0" class="font-size-14 mb-2 text-muted ml-auto align-self-sm-center">Character Count: 0 / {{item.character_count}}</p>
                      <div v-if="item.label == 'Practices'" class="form-check ml-auto align-self-center">
                          <input class="form-check-input" type="checkbox"/>
                          <label class="form-check-label ml-1">Select All</label>
                      </div>            
                    </div>
                    <div v-if="item.label == 'Practices'" style="border-bottom: 1px solid #DADCE3" class="mb-3">
                    </div>
                    <div v-if="item.type == 'file'" class="custom-file col-6">
                      <input :id="key + _uid" type="file" class="custom-file-input" />
                      <label class="custom-file-label" :for="key + _uid">Choose file</label>
                    </div>
                    <ckeditor v-else-if="item.type == 'ckeditor'" v-model="formData[key]" :editor="editor" :id="key + _uid"></ckeditor>
                    <div v-else-if="item.type == 'checkbox' && item.label == 'Days / Availability'" class="row mb-2">    
                      <div class="d-flex col-12"
                        v-for="option in item.options" :key="option.day">
                        <div class="col-6 form-check mb-3">
                            <input class="form-check-input my-3" type="checkbox" :value="option" :id="key + option + _uid"/>
                            <label class="form-check-label form-control ml-1 text-capitalize" :for="key + option + _uid">{{option.day}}</label>
                        </div>
                        <div class="col-6">
                            <select class="form-control">
                              <option>Select</option>
                              <option value="Morning">Morning</option>
                              <option value="Afternoon">Afternoon</option>
                              <option value="All Day">All Day</option>
                            </select>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.type == 'checkbox' && item.label == 'Practices'" class="row pl-3">
                      <div v-for="option in item.options" v-bind:key="option" class="form-check col-12 pb-2">
                          <input class="form-check-input" type="checkbox" v-model="formData[key][option]" :value="formData[key][option]" :id="option + _uid"/>
                          <label class="form-check-label ml-1" :for="option + _uid">{{option}}</label>
                      </div>                      
                    </div>
                    <div v-else-if="item.type == 'checkbox'" class="row pl-3">
                      <div v-for="option in item.options" v-bind:key="option" class="form-check col-12">
                          <input class="form-check-input" type="checkbox" v-model="formData[key][option]" :value="formData[key][option]" :id="option + _uid"/>
                          <label class="form-check-label ml-1" :for="option + _uid">{{option}}</label>
                      </div>                      
                    </div>
                    <div v-else-if="item.type == 'radio'" class="row container">
                      <div v-for="option in item.options" v-bind:key="option" class="form-check mr-4">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="exampleRadios"
                          :id="option + _uid"
                          v-model="formData[key][option]"
                          :checked="formData[key][option] == true"
                        />
                        <label class="form-check-label" :for="option + _uid">{{option}}</label>
                      </div>            
                    </div>
                    <div v-else-if="item.type == 'select'">
                      <select class="form-control">
                        <option v-for="option in item.options" v-bind:key="option"
                        :selected="formData[key] == option">{{option}}</option>
                      </select>
                    </div>
                    <input
                      v-else-if="item.type == 'text' || item.type == 'date' || item.type == 'number' || item.type == 'email'"
                      :id="key + _uid"
                      v-model="formData[key]"
                      :type="item.type"
                      class="form-control"
                      :placeholder="item.placeholder"
                    />
                    <b-form-group v-else-if="item.type == 'time'">
                      <b-form-input id="time" v-model="formData[key]" type="time"></b-form-input>
                    </b-form-group>
                    <p v-if="item.label == 'Slug'" class="ml-auto text-muted my-2 font-size-14 align-self-sm-center">farnhamdene.com/{{formData[key]}}</p>
                  </div>
                </div>                
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="chat-leftsidebar w-25 pl-4 pt-3" style="border-left: 1px solid #DADCE3;">
        <h4 class="card-title">Add Form Fields</h4>
        <p class="card-title-desc">Select respective fields and enter field's properties.</p>
        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab" style="background: #005EB8">
              <h6 class="m-0">
                <a
                  v-b-toggle.accordion-1
                  style="color: white"
                  href="javascript: void(0);"
                >Title</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body style="background: #f1f5f7">
                <b-card-text>
                  <input
                    v-model="form.title"
                    type="text"
                    class="form-control"
                    placeholder="Enter Title"
                  />
                <!-- <button @click.prevent="addTitle" class="btn btn-primary mt-3">Add</button> -->
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab" style="background: #005EB8">
              <h6 class="m-0">
                <a
                  v-b-toggle.accordion-1
                  style="color: white"
                  href="javascript: void(0);"
                >Heading</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body style="background: #f1f5f7">
                <b-card-text>
                  <input
                    v-model="form.heading.label"
                    type="text"
                    class="form-control"
                    placeholder="Enter Heading"
                  />
                <button @click.prevent="addHeading" class="btn btn-primary mt-3">Add</button>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab" style="background: #005EB8">
              <h6 class="m-0">
                <a
                  v-b-toggle.accordion-2
                  style="color: white"
                  href="javascript: void(0);"
                >Paragraph</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body style="background: #f1f5f7">
                <b-card-text>
                  <input
                    v-model="form.paragraph.label"
                    type="text"
                    class="form-control"
                    placeholder="Enter Paragraph"
                  />
                <button @click.prevent="addParagraph" class="btn btn-primary mt-3" type="submit">Add</button>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab" style="background: #005EB8">
              <h6 class="m-0">
                <a
                  v-b-toggle.accordion-3
                  style="color: white"
                  href="javascript: void(0);"
                >Input</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body style="background: #f1f5f7">
                <div class="d-flex">
                  <label
                  class="pr-2 my-2 align-self-sm-center"
                  for="inputtypeselect">Select Input Type<span> *</span></label>
                </div>
                <div>
                    <select class="form-control" v-model="form.input.type">
                      <option value="choose">Choose</option>
                      <option value="text">Text</option>
                      <option value="date">Date</option>
                      <option value="number">Number</option>
                      <option value="email">Email</option>
                      <option value="time">Time</option>
                      <option value="select">Select</option>
                      <option value="checkbox">Checkbox</option>
                      <option value="radio">Radio</option>
                    </select>
                </div> 
                <div v-if="form.input.type != 'checkbox'">
                  <div class="d-flex">
                    <label
                    class="pr-2 my-2 align-self-sm-center"
                    for="inputtypeselect">Label<span> *</span></label>
                  </div>
                  <input
                    v-model="form.input.label"
                    type="text"
                    class="form-control"
                    placeholder="Enter Label"
                  />
                </div>
                <div class="d-flex py-3">
                  <div class="form-check col-12">
                      <input class="form-check-input" type="checkbox" v-model="form.input.required" :value="form.input.required"/>
                      <label class="form-check-label ml-1">Required</label>
                  </div>
                </div>
                <div class="d-flex pb-3">
                  <div class="form-check col-12">
                      <input class="form-check-input" type="checkbox" v-model="form.input.info" :value="form.input.info"/>
                      <label class="form-check-label ml-1">Info</label>
                  </div>
                </div>
                <div v-if="form.input.type != 'time'">
                  <div class="d-flex">
                    <label
                    class="pr-2 my-2 align-self-sm-center"
                    for="inputtypeselect">Placeholder<span> *</span></label>
                  </div>
                  <input
                    v-model="form.input.placeholder"
                    type="text"
                    class="form-control"
                    placeholder="Enter Placeholder"
                  />                  
                </div>
                <div v-if="form.input.type == 'radio' || form.input.type == 'select' || form.input.type == 'checkbox'">
                  <div class="d-flex">
                    <label
                    class="pr-2 my-2 align-self-sm-center"
                    for="inputtypeselect">Options<span> *</span></label>
                  </div>
                  <div class="d-flex">
                    <input
                      v-model="tempOption"
                      type="text"
                      class="form-control col-10"
                      placeholder="Enter option"
                    />     
                    <i
                    @click.prevent="addOption"
                    class="ri-add-circle-fill text-primary b-avatar col-2 font-size-36 ml-2"></i>
                  </div>
                  <div 
                  v-for="o,key in form.input.options" :key="key"
                  class="alert alert-primary alert-dismissible fade show" role="alert">
                    {{o}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span @click="deleteOption(o)" aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="d-flex">
                  <label
                  class="pr-2 my-2 align-self-sm-center"
                  for="inputtypeselect">Character Count<span> (optional)</span></label>
                </div>
                <input
                  v-model="form.input.character_count"
                  type="number"
                  class="form-control"
                  placeholder="Enter Character Count"
                />
                <div class="d-flex">
                  <label
                  class="pr-2 my-2 align-self-sm-center"
                  for="inputtypeselect">Class<span> (optional)</span></label>
                </div>
                <input
                  v-model="form.input.wrapper_class"
                  type="text"
                  class="form-control"
                  placeholder="Enter Class"
                />
                <button @click.prevent="addInput" class="btn btn-primary mt-3" type="submit">Add</button>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>

  </Layout>
</template>